const storageKey = 'offworld.show-fps.v1';

/** Frame cadence (including visible stalls), rather than CPU/GPU render duration. */
export class FPSOverlay {
  private events = new AbortController();
  private start: number | null = null;
  private frames = 0;
  private enabled = false;

  constructor(toggles: HTMLInputElement[], private overlay: HTMLElement) {
    try { this.enabled = localStorage.getItem(storageKey) === 'true'; } catch { /* Storage may be unavailable. */ }
    const sync = () => { for (const toggle of toggles) toggle.checked = this.enabled; overlay.hidden = !this.enabled; this.reset(); };
    sync();
    for (const toggle of toggles) toggle.addEventListener('change', () => {
      this.enabled = toggle.checked; sync();
      try { localStorage.setItem(storageKey, String(this.enabled)); } catch { /* The toggle still works without persistence. */ }
    }, { signal: this.events.signal });
    document.addEventListener('visibilitychange', () => this.reset(), { signal: this.events.signal });
  }

  private reset(): void {
    this.start = null; this.frames = 0;
    this.overlay.textContent = '— FPS · — ms';
  }

  frame(now: number): void {
    if (!this.enabled || document.hidden) return;
    if (this.start === null) { this.start = now; return; }
    this.frames++;
    const elapsed = now - this.start;
    if (elapsed < 500) return;
    this.overlay.textContent = `${(this.frames * 1000 / elapsed).toFixed(0)} FPS · ${(elapsed / this.frames).toFixed(1)} ms`;
    this.start = now; this.frames = 0;
  }

  dispose(): void { this.events.abort(); }
}
